import React from 'react';

type IconProps = {
    color?: string;
    width?: number;
    height?: number;
};

const IconEmojiHappy: React.FC<IconProps> = ({ color, width = 19, height = 19 }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 17 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.49923 17.4994C0.904834 17.4994 -0.0103314 10.919 8.69511e-05 9.27387V8.7255C-0.0103314 7.0804 0.904834 0.5 8.49923 0.5C16.0936 0.5 17.0088 7.0804 16.9984 8.7255V9.27387C17.0088 10.919 16.0936 17.4994 8.49923 17.4994Z"
                fill="url(#paint0_linear_10750_11201)"
            />
            <path
                d="M13.1067 10.3822C13.1493 10.3728 13.1936 10.3738 13.2357 10.3852C13.2779 10.3966 13.3167 10.418 13.3487 10.4476C13.3808 10.4773 13.4052 10.5143 13.4199 10.5554C13.4345 10.5965 13.439 10.6406 13.4329 10.6838C13.4131 10.9116 13.3736 11.1373 13.315 11.3583C11.8446 12.1794 10.1829 12.5963 8.49903 12.5664C6.81509 12.596 5.15338 12.1789 3.68303 11.3575C3.62441 11.1365 3.58497 10.9108 3.56514 10.683C3.55905 10.6398 3.56353 10.5957 3.57819 10.5546C3.59286 10.5134 3.61727 10.4765 3.64933 10.4468C3.6814 10.4172 3.72017 10.3957 3.76232 10.3844C3.80448 10.373 3.84877 10.372 3.8914 10.3814C5.39149 10.8022 6.94108 11.0206 8.49903 11.031C10.0569 11.0209 11.6065 10.8027 13.1067 10.3822Z"
                fill="url(#paint1_linear_10750_11201)"
            />
            <path
                d="M13.4364 10.372H13.4342C13.435 10.3316 13.4267 10.2915 13.4097 10.2548C13.3927 10.2181 13.3676 10.1857 13.3363 10.1602C13.3049 10.1346 13.2681 10.1166 13.2288 10.1074C13.1894 10.0982 13.1484 10.0981 13.109 10.1071C11.6089 10.5276 10.0593 10.7458 8.50139 10.7558C6.94344 10.7455 5.39386 10.5271 3.89376 10.1063C3.85428 10.0973 3.81325 10.0974 3.77381 10.1066C3.73437 10.1159 3.69757 10.134 3.6662 10.1596C3.63483 10.1852 3.60974 10.2177 3.59282 10.2545C3.57591 10.2913 3.56762 10.3315 3.5686 10.372H3.56641V10.6462H3.5686C3.56777 10.6583 3.56777 10.6705 3.5686 10.6826C3.58843 10.9104 3.62787 11.1361 3.68649 11.3571C3.72217 11.5023 3.76704 11.6451 3.82083 11.7846C4.1084 12.5141 4.59108 13.1505 5.21606 13.6241C6.15043 14.3669 7.30886 14.7713 8.50249 14.7713C9.69612 14.7713 10.8545 14.3669 11.7889 13.6241C12.4139 13.1505 12.8966 12.5141 13.1841 11.7846C13.2379 11.6451 13.2828 11.5023 13.3185 11.3571C13.3771 11.1361 13.4166 10.9104 13.4364 10.6826C13.4372 10.6705 13.4372 10.6583 13.4364 10.6462V10.372Z"
                fill="#ED8D06"
            />
            <path
                d="M13.4342 10.6474C13.435 10.607 13.4267 10.5669 13.4097 10.5302C13.3927 10.4935 13.3676 10.4611 13.3363 10.4356C13.3049 10.41 13.2681 10.392 13.2288 10.3828C13.1894 10.3736 13.1484 10.3735 13.109 10.3825C11.6089 10.803 10.0593 11.0212 8.50139 11.0312C6.94344 11.0209 5.39386 10.8025 3.89376 10.3817C3.85428 10.3727 3.81325 10.3728 3.77381 10.382C3.73437 10.3912 3.69757 10.4094 3.6662 10.435C3.63483 10.4606 3.60974 10.4931 3.59282 10.5299C3.57591 10.5667 3.56762 10.6069 3.5686 10.6474H3.56641V10.9216H3.5686C3.56777 10.9337 3.56777 10.9459 3.5686 10.958C3.58843 11.1858 3.62787 11.4115 3.68649 11.6325C3.72217 11.7777 3.76704 11.9205 3.82083 12.06C4.1084 12.7895 4.59108 13.4259 5.21606 13.8995C6.15043 14.6423 7.30886 15.0467 8.50249 15.0467C9.69612 15.0467 10.8545 14.6423 11.7889 13.8995C12.4139 13.4259 12.8966 12.7895 13.1841 12.06C13.2379 11.9205 13.2828 11.7777 13.3185 11.6325C13.3771 11.4115 13.4166 11.1858 13.4364 10.958C13.4372 10.9459 13.4372 10.9337 13.4364 10.9216V10.6474H13.4342Z"
                fill="#F9BF06"
            />
            <path
                d="M10.3949 14.4176C9.17109 14.871 7.82539 14.871 6.60156 14.4176C6.69176 14.1791 7.1 13.3867 8.49824 13.3867C9.89649 13.3867 10.3047 14.1791 10.3949 14.4176Z"
                fill="#8F030E"
            />
            <path
                d="M13.1813 11.7835C12.8937 12.513 12.411 13.1494 11.786 13.623C11.3663 13.9578 10.8976 14.226 10.3963 14.4181C10.3061 14.1793 9.89784 13.3869 8.49959 13.3869C7.10135 13.3869 6.69311 14.179 6.60291 14.4176C6.10158 14.2254 5.63284 13.9573 5.21317 13.6224C4.58818 13.1488 4.1055 12.5125 3.81794 11.7829C3.76411 11.6434 3.71923 11.5007 3.68359 11.3555C5.15394 12.1769 6.81566 12.594 8.49959 12.5643C10.1835 12.594 11.8452 12.1769 13.3156 11.3555C13.28 11.5009 13.2351 11.6438 13.1813 11.7835Z"
                fill="url(#paint2_linear_10750_11201)"
            />
            <path
                d="M13.1067 10.3822C13.1493 10.3728 13.1936 10.3738 13.2357 10.3852C13.2779 10.3966 13.3167 10.418 13.3487 10.4476C13.3808 10.4773 13.4052 10.5143 13.4199 10.5554C13.4345 10.5965 13.439 10.6406 13.4329 10.6838C13.4131 10.9116 13.3736 11.1373 13.315 11.3583C11.8446 12.1794 10.1829 12.5963 8.49903 12.5664C6.81509 12.596 5.15338 12.1789 3.68303 11.3575C3.62441 11.1365 3.58497 10.9108 3.56514 10.683C3.55905 10.6398 3.56353 10.5957 3.57819 10.5546C3.59286 10.5134 3.61727 10.4765 3.64933 10.4468C3.6814 10.4172 3.72017 10.3957 3.76232 10.3844C3.80448 10.373 3.84877 10.372 3.8914 10.3814C5.39149 10.8022 6.94108 11.0206 8.49903 11.031C10.0569 11.0209 11.6065 10.8027 13.1067 10.3822Z"
                fill="url(#paint3_linear_10750_11201)"
            />
            <path
                d="M13.1067 10.3822C13.1493 10.3728 13.1936 10.3738 13.2357 10.3852C13.2779 10.3966 13.3167 10.418 13.3487 10.4476C13.3808 10.4773 13.4052 10.5143 13.4199 10.5554C13.4345 10.5965 13.439 10.6406 13.4329 10.6838C13.4131 10.9116 13.3736 11.1373 13.315 11.3583C11.8446 12.1794 10.1829 12.5963 8.49903 12.5664C6.81509 12.596 5.15338 12.1789 3.68303 11.3575C3.62441 11.1365 3.58497 10.9108 3.56514 10.683C3.55905 10.6398 3.56353 10.5957 3.57819 10.5546C3.59286 10.5134 3.61727 10.4765 3.64933 10.4468C3.6814 10.4172 3.72017 10.3957 3.76232 10.3844C3.80448 10.373 3.84877 10.372 3.8914 10.3814C5.39149 10.8022 6.94108 11.0206 8.49903 11.031C10.0569 11.0209 11.6065 10.8027 13.1067 10.3822Z"
                fill="url(#paint4_linear_10750_11201)"
            />
            <path
                d="M15.7565 3.74794C14.4158 3.39754 13.7093 4.06353 13.7093 4.06353C13.7093 4.06353 13.3435 3.11732 12.0029 2.76692C11.7937 2.69597 11.5719 2.66989 11.352 2.69037C11.1321 2.71086 10.919 2.77745 10.7266 2.88581C10.5341 2.99418 10.3667 3.14187 10.2351 3.31929C10.1036 3.4967 10.0109 3.69984 9.96306 3.91547C9.85408 4.30623 9.84176 4.71762 9.92714 5.1142C10.3401 6.69302 11.1734 8.1303 12.3384 9.27302C13.885 8.84611 15.2773 7.9857 16.3508 6.7933C16.6272 6.49335 16.8272 6.13128 16.934 5.73769C17.0777 5.2151 17.0971 4.09835 15.7565 3.74794Z"
                fill="#EC3A4A"
            />
            <path
                d="M15.7565 3.74793C14.4158 3.39752 13.7093 4.06351 13.7093 4.06351C13.7093 4.06351 13.3435 3.1173 12.0029 2.7669C11.7937 2.69595 11.5719 2.66988 11.352 2.69038C11.1321 2.71088 10.9189 2.7775 10.7265 2.88589C10.534 2.99428 10.3666 3.14201 10.235 3.31946C10.1035 3.4969 10.0108 3.70007 9.96305 3.91573C9.85408 4.30639 9.84176 4.71769 9.92714 5.11418C10.3401 6.693 11.1734 8.13028 12.3384 9.273C13.885 8.8461 15.2773 7.98568 16.3508 6.79328C16.6272 6.49333 16.8272 6.13126 16.934 5.73768C17.0777 5.21508 17.0971 4.09833 15.7565 3.74793Z"
                fill="url(#paint5_linear_10750_11201)"
            />
            <path
                d="M11.7827 3.257C13.1782 3.62222 13.5681 4.57473 13.5681 4.57473C13.5681 4.57473 14.2949 3.91422 15.6904 4.27943C16.5779 4.51167 16.8967 5.04852 16.9748 5.54315C17.0645 4.97614 16.9474 4.06009 15.7562 3.74862C14.4155 3.39821 13.709 4.0642 13.709 4.0642C13.709 4.0642 13.3432 3.11799 12.0026 2.76759C10.8248 2.45968 10.2545 3.17557 10.0352 3.70776C10.3576 3.32582 10.9067 3.02779 11.7827 3.257Z"
                fill="url(#paint6_linear_10750_11201)"
            />
            <path
                d="M15.152 5.73764C15.1426 5.8047 15.1483 5.87301 15.1687 5.93758C15.1891 6.00215 15.2236 6.06134 15.2699 6.11081C15.3161 6.16029 15.3728 6.19879 15.4359 6.22351C15.4989 6.24822 15.5667 6.25852 15.6342 6.25365C15.7344 6.2428 15.8328 6.21931 15.927 6.18373C16.0784 6.1306 16.2098 6.03216 16.3033 5.90177C16.3967 5.77139 16.4478 5.61538 16.4496 5.45495C16.4343 5.28821 16.3662 5.1307 16.2552 5.00529C16.0575 4.76922 15.3598 4.40017 15.1215 4.76483C15.0119 4.93346 15.1533 5.23451 15.1632 5.42068C15.1685 5.52646 15.1648 5.6325 15.152 5.73764Z"
                fill="url(#paint7_linear_10750_11201)"
            />
            <path
                d="M12.6419 4.81736C12.6279 5.01368 12.7241 5.18257 12.8338 5.16119C12.8755 5.15337 12.9154 5.13754 12.9511 5.11458C13.0227 5.05651 13.0791 4.98199 13.1156 4.89739C13.1521 4.81279 13.1677 4.72062 13.1609 4.62872C13.1566 4.52444 13.1302 4.42226 13.0833 4.32904C13.004 4.17166 12.7249 3.92572 12.6298 4.16864C12.6113 4.3148 12.6169 4.46301 12.6465 4.60734C12.6485 4.67738 12.6469 4.74747 12.6419 4.81736Z"
                fill="url(#paint8_linear_10750_11201)"
            />
            <path
                d="M1.24272 3.74793C2.5834 3.39752 3.28992 4.06351 3.28992 4.06351C3.28992 4.06351 3.65566 3.1173 4.99633 2.7669C5.2055 2.69595 5.42727 2.66988 5.64719 2.69038C5.86711 2.71088 6.08024 2.7775 6.27269 2.88589C6.46514 2.99428 6.6326 3.14201 6.76414 3.31946C6.89568 3.4969 6.98835 3.70007 7.03612 3.91573C7.14509 4.30639 7.15742 4.71769 7.07204 5.11418C6.65909 6.693 5.82575 8.13028 4.66075 9.273C3.11415 8.8461 1.72191 7.98568 0.648332 6.79328C0.372029 6.49333 0.172007 6.13126 0.0651808 5.73768C-0.0784821 5.21508 -0.0979479 4.09833 1.24272 3.74793Z"
                fill="url(#paint9_linear_10750_11201)"
            />
            <path
                d="M5.21576 3.257C3.82026 3.62221 3.43039 4.57473 3.43039 4.57473C3.43039 4.57473 2.70358 3.91422 1.30807 4.27943C0.4206 4.51166 0.101745 5.04851 0.0236074 5.54314C-0.0660448 4.97613 0.051024 4.06008 1.24227 3.74861C2.58295 3.3982 3.28947 4.0642 3.28947 4.0642C3.28947 4.0642 3.65521 3.11799 4.99588 2.76758C6.17479 2.45967 6.74533 3.17557 6.96412 3.70885C6.64088 3.32582 6.09172 3.02778 5.21576 3.257Z"
                fill="url(#paint10_linear_10750_11201)"
            />
            <path
                d="M5.49558 4.75184C5.52493 4.81286 5.56754 4.86654 5.62031 4.90895C5.67308 4.95137 5.73467 4.98144 5.80056 4.99698C5.86646 5.01251 5.93499 5.01311 6.00115 4.99874C6.06731 4.98436 6.12941 4.95537 6.18292 4.91388C6.26028 4.84921 6.3291 4.77495 6.38772 4.69289C6.484 4.56474 6.53852 4.41007 6.54386 4.24986C6.54921 4.08966 6.50513 3.93169 6.4176 3.79741C6.31227 3.66723 6.16823 3.57399 6.00635 3.53118C5.7108 3.44426 4.92559 3.52432 4.9297 3.96C4.93135 4.16125 5.21676 4.33316 5.32807 4.48259C5.39143 4.56744 5.44747 4.65751 5.49558 4.75184Z"
                fill="url(#paint11_linear_10750_11201)"
            />
            <path
                d="M2.89713 5.37291C2.99446 5.544 3.16855 5.63091 3.24834 5.55222C3.27867 5.52253 3.30297 5.48724 3.31989 5.44831C3.3471 5.36019 3.35261 5.2668 3.33595 5.1761C3.31929 5.08539 3.28096 5.00006 3.22421 4.92736C3.16264 4.84297 3.08386 4.7726 2.99309 4.7209C2.8401 4.63398 2.47217 4.58381 2.52701 4.83935C2.55278 4.95725 2.71152 5.09269 2.78363 5.19387C2.82448 5.25227 2.86231 5.31204 2.89713 5.37291Z"
                fill="url(#paint12_linear_10750_11201)"
            />
            <path
                d="M9.92592 5.11749C9.84053 4.72101 9.85286 4.3097 9.96183 3.91904C10.0287 3.68278 10.1404 3.4616 10.2908 3.26758C9.9983 3.50579 9.78743 3.82939 9.68766 4.19322C9.57869 4.58388 9.56637 4.99519 9.65175 5.39168C10.0648 6.97047 10.8981 8.40773 12.063 9.55049C13.5348 9.146 14.8677 8.34627 15.9173 7.23803C14.9135 8.20667 13.6825 8.90755 12.3372 9.27631C11.1723 8.13355 10.3389 6.69629 9.92592 5.11749Z"
                fill="#ED8D06"
            />
            <path
                d="M7.07084 5.11749C6.65744 6.69644 5.82363 8.13371 4.65818 9.27631C3.31293 8.90755 2.08189 8.20667 1.07812 7.23803C2.12768 8.34627 3.46061 9.146 4.93235 9.55049C6.0978 8.4079 6.93161 6.97062 7.34501 5.39168C7.43039 4.99519 7.41806 4.58388 7.30909 4.19322C7.20932 3.82939 6.99846 3.50579 6.70593 3.26758C6.85639 3.4616 6.96809 3.68278 7.03493 3.91904C7.1439 4.3097 7.15622 4.72101 7.07084 5.11749Z"
                fill="#ED8D06"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_10750_11201"
                    x1="8.49923"
                    y1="0.583352"
                    x2="8.49923"
                    y2="17.5827"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FFE100" />
                    <stop offset="1" stopColor="#F98900" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_10750_11201"
                    x1="3.56404"
                    y1="11.4699"
                    x2="13.434"
                    y2="11.4699"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#B8B4B2" />
                    <stop offset="0.143" stopColor="#D0CCC9" />
                    <stop offset="0.374" stopColor="#F2EDEA" />
                    <stop offset="0.5" stopColor="#FFFAF6" />
                    <stop offset="0.638" stopColor="#F9F5F1" />
                    <stop offset="0.825" stopColor="#E8E5E3" />
                    <stop offset="1" stopColor="#D1D1D1" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_10750_11201"
                    x1="8.49959"
                    y1="14.8332"
                    x2="8.49959"
                    y2="10.3821"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#69101B" />
                    <stop offset="0.427" stopColor="#400A10" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_10750_11201"
                    x1="8.49903"
                    y1="10.6918"
                    x2="8.49903"
                    y2="12.5349"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#B8B4B2" />
                    <stop offset="0.143" stopColor="#D0CCC9" />
                    <stop offset="0.374" stopColor="#F2EDEA" />
                    <stop offset="0.5" stopColor="#FFFAF6" />
                    <stop offset="0.638" stopColor="#F9F5F1" />
                    <stop offset="0.825" stopColor="#E8E5E3" />
                    <stop offset="1" stopColor="#D1D1D1" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_10750_11201"
                    x1="8.49903"
                    y1="10.6918"
                    x2="8.49903"
                    y2="12.5349"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#ABABAB" stopOpacity="0.5" />
                    <stop offset="0.541" stopColor="#C1C1C1" stopOpacity="0.216" />
                    <stop offset="1" stopColor="#D1D1D1" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint5_linear_10750_11201"
                    x1="14.1531"
                    y1="2.75045"
                    x2="11.9785"
                    y2="9.16626"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF5F6F" />
                    <stop offset="0.346" stopColor="#FF2D44" />
                    <stop offset="0.722" stopColor="#D41E32" />
                    <stop offset="0.853" stopColor="#D61F33" />
                    <stop offset="0.918" stopColor="#DE2337" />
                    <stop offset="0.968" stopColor="#EB293E" />
                    <stop offset="1" stopColor="#F82F44" />
                </linearGradient>
                <linearGradient
                    id="paint6_linear_10750_11201"
                    x1="13.8929"
                    y1="2.66586"
                    x2="13.4147"
                    y2="5.07949"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF8A95" />
                    <stop offset="0.66" stopColor="#FF495D" />
                    <stop offset="1" stopColor="#FF2D44" />
                </linearGradient>
                <linearGradient
                    id="paint7_linear_10750_11201"
                    x1="15.9109"
                    y1="4.81144"
                    x2="15.4151"
                    y2="6.22457"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF5F5F" />
                    <stop offset="0.283" stopColor="#FF565A" />
                    <stop offset="0.746" stopColor="#FF3D4D" />
                    <stop offset="1" stopColor="#FF2D44" />
                </linearGradient>
                <linearGradient
                    id="paint8_linear_10750_11201"
                    x1="12.992"
                    y1="4.19113"
                    x2="12.6665"
                    y2="5.11922"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF5F5F" />
                    <stop offset="0.283" stopColor="#FF565A" />
                    <stop offset="0.746" stopColor="#FF3D4D" />
                    <stop offset="1" stopColor="#FF2D44" />
                </linearGradient>
                <linearGradient
                    id="paint9_linear_10750_11201"
                    x1="2.84605"
                    y1="2.75045"
                    x2="5.02071"
                    y2="9.16626"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF5F6F" />
                    <stop offset="0.346" stopColor="#FF2D44" />
                    <stop offset="0.722" stopColor="#D41E32" />
                    <stop offset="0.853" stopColor="#D61F33" />
                    <stop offset="0.918" stopColor="#DE2337" />
                    <stop offset="0.968" stopColor="#EB293E" />
                    <stop offset="1" stopColor="#F82F44" />
                </linearGradient>
                <linearGradient
                    id="paint10_linear_10750_11201"
                    x1="3.10551"
                    y1="2.66586"
                    x2="3.58371"
                    y2="5.07949"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF8A95" />
                    <stop offset="0.66" stopColor="#FF495D" />
                    <stop offset="1" stopColor="#FF2D44" />
                </linearGradient>
                <linearGradient
                    id="paint11_linear_10750_11201"
                    x1="5.6153"
                    y1="3.55133"
                    x2="5.98702"
                    y2="5.00195"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF5F5F" />
                    <stop offset="0.283" stopColor="#FF565A" />
                    <stop offset="0.746" stopColor="#FF3D4D" />
                    <stop offset="1" stopColor="#FF2D44" />
                </linearGradient>
                <linearGradient
                    id="paint12_linear_10750_11201"
                    x1="2.84323"
                    y1="4.65071"
                    x2="3.08734"
                    y2="5.60367"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF5F5F" />
                    <stop offset="0.283" stopColor="#FF565A" />
                    <stop offset="0.746" stopColor="#FF3D4D" />
                    <stop offset="1" stopColor="#FF2D44" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default IconEmojiHappy;
